import { all, put, call, takeEvery } from "redux-saga/effects";
import axios from "axios";
import { getlocalstorage } from "./../../../constants/local_storage";
//import { push } from "connected-react-router";

import * as actions from "./actions";
import moment from "moment";

function* loadDrivinglog(action) {
  const COMPANY_ID = getlocalstorage(
    localStorage.getItem("profile"),
    "company_id"
  );
  const USER_ID = getlocalstorage(localStorage.getItem("profile"), "id");

  const vehicle_visibility = getlocalstorage(
    localStorage.getItem("profile"),
    "vehicle_visibility"
  );

  const {
    data: {
      list_vehicle_id,
      vehicle_type_id,
      eventdate,
      vehicle_status,
      type_file,
      event_type,
      gps_not_fixed,
      policy_id,
    },
  } = action.payload;
  const date_start = moment(eventdate[0]["_d"]).format("YYYY-MM-DD HH:mm");
  const date_end = moment(eventdate[1]["_d"]).format("YYYY-MM-DD HH:mm");
  const temp_gps_not_fixed = gps_not_fixed ? 1 : 0;

  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_API_REPORT_GOLANG_MONGO}/reports/go/drivinglog2`,
      {
        date_start,
        date_end,
        list_vehicle_id,
        company_id: COMPANY_ID,
        vehicle_type_id: `${vehicle_type_id}`,
        user_id: USER_ID,
        vehicle_status,
        type_file,
        vehicle_visibility,
        policy_id,
        event_type,
        gps_not_fixed: temp_gps_not_fixed,
      }
      //  { headers: { Authorization: `Bearer ${ACCESSTOKEN}` } }
    );

    yield put(actions.loadDrivinglog.success(res.data));
    window.location = res.data.result;
  } catch (err) {
    yield put(actions.loadDrivinglog.failure());
  }
}

function* loadVehicle(action) {
  const ACCESSTOKEN = localStorage.getItem("access-token");
  const COMPANY_ID = getlocalstorage(
    localStorage.getItem("profile"),
    "company_id"
  );

  const vehicle_visibility = getlocalstorage(
    localStorage.getItem("profile"),
    "vehicle_visibility"
  );

  const { vehicletypeID } = action.payload;
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/getvehiclebygroupid`,
      {
        companyID: COMPANY_ID,
        vehicletypeID: vehicletypeID,
        allow_vehicles: vehicle_visibility,
      },
      { headers: { Authorization: `Bearer ${ACCESSTOKEN}` } }
    );
    yield put(actions.loadVehicle.success(res.data));
  } catch (err) {
    yield put(actions.loadVehicle.failure());
  }
}

function* loadVehicleType(action) {
  const ACCESSTOKEN = localStorage.getItem("access-token");
  const COMPANY_ID = getlocalstorage(
    localStorage.getItem("profile"),
    "company_id"
  );

  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/getgroupvehicle`,
      {
        company_id: COMPANY_ID,
      },
      {
        headers: { Authorization: `Bearer ${ACCESSTOKEN}` },
      }
    );
    yield put(actions.loadVehicleType.success(res.data));
  } catch (err) {
    yield put(actions.loadVehicleType.failure());
  }
}

function* loadTopics() {
  const COMPANY_ID = getlocalstorage(
    localStorage.getItem("profile"),
    "company_id"
  );
  const USER_ID = getlocalstorage(localStorage.getItem("profile"), "id");
  // Define your username and password
  const username = "eventdasbbaord";
  const password = "66e49accea2f72036676811d72aa6d51";

  // Encode the username and password for the Basic Auth header
  const authHeader =
    "Basic " + Buffer.from(`${username}:${password}`).toString("base64");

  try {
    const res = yield call(
      axios.get,
      `${process.env.REACT_APP_API_EVENT_DASHBOARD}/user/topics`,
      {
        params: { company_id: COMPANY_ID, user_id: USER_ID },
        headers: { Authorization: authHeader },
      }
    );
    yield put(actions.loadTopics.success(res.data));
  } catch (err) {
    yield put(actions.loadTopics.failure());
  }
}

function* loadPolicy() {
  const ACCESSTOKEN = localStorage.getItem("access-token");
  const COMPANY_ID = getlocalstorage(
    localStorage.getItem("profile"),
    "company_id"
  );

  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/getpolicy-for-eventrpt`,
      {
        company_id: COMPANY_ID,
      },
      {
        headers: { Authorization: `Bearer ${ACCESSTOKEN}` },
      }
    );
    yield put(actions.loadPolicy.success(res.data));
  } catch (err) {
    yield put(actions.loadPolicy.failure());
  }
}

function* loadEvent() {
  const ACCESSTOKEN = localStorage.getItem("access-token");
  const COMPANY_ID = getlocalstorage(
    localStorage.getItem("profile"),
    "company_id"
  );

  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/getevent`,
      {
        company_id: COMPANY_ID,
      },
      {
        headers: { Authorization: `Bearer ${ACCESSTOKEN}` },
      }
    );

    const events = {
      data: [
        ...res.data.data,
        { id: -1, name: "ความเร็วเกินกำหนด", event_type: "1001" },
        { id: -2, name: "การรูดใบขับขี่", event_type: "7007" },
      ],
    };

    yield put(actions.loadEvent.success(events));
  } catch (err) {
    yield put(actions.loadEvent.failure());
  }
}

export default function* watchReportPoolState() {
  yield all([
    takeEvery(actions.LOAD_DRIVINGLOG.REQUEST, loadDrivinglog),
    takeEvery(actions.LOAD_VEHICLE_DRIVINGLOG.REQUEST, loadVehicle),
    takeEvery(actions.LOAD_VEHICLE_TYPE_DRIVINGLOG.REQUEST, loadVehicleType),
    takeEvery(actions.LOAD_TOPICS_DRIVINGLOG.REQUEST, loadTopics),
    takeEvery(actions.LOAD_POLICY_DRIVINGLOG.REQUEST, loadPolicy),
    takeEvery(actions.LOAD_EVENT_DRIVINGLOG.REQUEST, loadEvent),
  ]);
}

export { loadDrivinglog, loadVehicle, loadVehicleType, loadTopics };
